import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.modal = new Modal(this.element)
    this._resetForCache = () => this.resetForCache()
    document.addEventListener('turbo:before-cache', this._resetForCache)
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this._resetForCache)
  }

  contentTargetConnected() {
    if (this.modal === undefined) {
      this.modal = new Modal(this.element)
    }
    this.modal.show()
  }

  contentTargetDisconnected() {
    this.modal.hide()
  }

  resetForCache() {
    this.modal.hide()
    // Synchronously strip all Bootstrap modal artifacts so the Turbo cache
    // snapshot is clean — otherwise restoring the page re-opens the modal.
    this.element.classList.remove('show')
    this.element.style.removeProperty('display')
    document.body.classList.remove('modal-open')
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove())
    const contentEl = document.getElementById('modal-content')
    if (contentEl) contentEl.innerHTML = ''
  }
}